import { getPlatformName } from '@/src/shared/utils/socials';
import {
  ShareSocialMetadata,
  SocialMetadata,
  Socials,
} from '@/src/shared/types/socials';

export const socialMediaIcons = {
  square: {
    instagram: `/images/icons/social/v2/instagram.svg`,
    instagram_2: `/images/icons/social/instagram-transparent.png`,
    instagram_3: `/images/icons/social/v3/instagram.png`,
    instagram_business: `/images/icons/social/v2/instagram.svg`,
    facebook: `/images/icons/social/v2/facebook.svg`,
    facebook_2: `/images/icons/social/v2/facebook_2.png`,
    facebook_3: `/images/icons/social/v3/facebook.svg`,
    'facebook-profile': `/images/icons/social/v2/facebook.svg`,
    linkedin: `/images/icons/social/v2/linkedin.svg`,
    linkedin_3: `/images/icons/social/v3/linkedin.svg`,
    stories: `/images/icons/social/stories-and-reels.svg`,
    stories_dark: `/images/icons/social/stories-and-reels-dark.svg`,
    twitter: `/images/icons/social/v2/twitter.svg`,
    twitter_3: `/images/icons/social/v3/x.svg`,
    tiktok: `/images/icons/social/v2/tiktok.svg`,
    wordpress: `/images/icons/social/v2/wordpress.svg`,
    tiktok_3: `/images/icons/social/v3/tiktok.svg`,
    youtube: `/images/icons/social/youtube-colored.svg`,
    youtube_3: `/images/icons/social/v3/youtube.svg`,
    google_my_business: `/next-public/icons/socials/colored/google-my-business-icon.svg`,
  },
  circle: {
    instagram: `/images/icons/social/circle/instagram.svg`,
    instagram_business: `/images/icons/social/circle/instagram.svg`,
    facebook: `/images/icons/social/circle/facebook.svg`,
    facebook_2: `/images/icons/social/circle/facebook.svg`,
    'facebook-profile': `/images/icons/social/v2/facebook.svg`,
    linkedin: `/images/icons/social/circle/linkedin.svg`,
    twitter: `/images/icons/social/circle/twitter.svg`,
    tiktok: `/images/icons/social/circle/tiktok.svg`,
    youtube: `/images/icons/social/youtube-colored.svg`,
    google_my_business: `/next-public/icons/socials/colored/google-my-business-icon.svg`,
  },
  black: {
    instagram: `/images/icons/social/instagram.svg`,
    instagram_business: `/images/icons/social/instagram.svg`,
    facebook: `/images/icons/social/facebook.svg`,
    facebook_2: `/images/icons/social/facebook.svg`,
    'facebook-profile': `/images/icons/social/facebook.svg`,
    linkedin: `/images/icons/social/linkedin.svg`,
    twitter: `/images/icons/social/twitter.svg`,
    tiktok: `/images/icons/social/tiktok.svg`,
    youtube: `/images/icons/social/youtube.svg`,
    google_my_business: `/images/icons/social/circle/google-my-business-svgrepo-com.svg`,
  },
  white: {
    instagram: `/images/icons/social/instagram-white.svg`,
    instagram_business: `/images/icons/social/instagram-white.svg`,
    facebook: `/images/icons/social/facebook-white.svg`,
    facebook_2: `/images/icons/social/facebook-white.svg`,
    'facebook-profile': `/images/icons/social/facebook-white.svg`,
    linkedin: `/images/icons/social/linkedin-white.svg`,
    twitter: `/images/icons/social/twitter-white.svg`,
    tiktok: `/images/icons/social/tiktok-white.svg`,
    youtube: `/images/icons/social/youtube-white.svg`,
    google_my_business: `/images/icons/social/circle/google-my-business-svgrepo-com.svg`,
  },
  blue30: {
    instagram: `/images/icons/social/blue-30/instagram.svg`,
    instagram_business: `/images/icons/social/blue-30/instagram.svg`,
    facebook: `/images/icons/social/blue-30/facebook.svg`,
    facebook_2: `/images/icons/social/blue-30/facebook.svg`,
    'facebook-profile': `/images/icons/social/blue-30/facebook.svg`,
    linkedin: `/images/icons/social/blue-30/linkedin.svg`,
    twitter: `/images/icons/social/blue-30/twitter.svg`,
    tiktok: `/images/icons/social/blue-30/tiktok.svg`,
    youtube: `/images/icons/social/blue-30/youtube.svg`,
  },
  gray: {
    instagram: `/images/icons/social/gray/instagram.svg`,
    instagram_business: `/images/icons/social/gray/instagram.svg`,
    facebook: `/images/icons/social/gray/facebook.svg`,
    facebook_2: `/images/icons/social/gray/facebook.svg`,
    'facebook-profile': `/images/icons/social/gray/facebook.svg`,
    linkedin: `/images/icons/social/gray/linkedin.svg`,
    stories: `/images/icons/social/stories-and-reels.svg`,
    twitter: `/images/icons/social/gray/twitter.svg`,
    tiktok: `/images/icons/social/gray/tiktok.svg`,
    youtube: `/images/icons/social/gray/youtube.svg`,
    '900': {
      instagram: `/images/icons/social/gray/900/instagram.svg`,
    },
    google_my_business: '/images/icons/social/icons8-google-business-50.png',
  },
  darkGray: {
    instagram: `/images/icons/social/dark-gray/instagram.svg`,
    instagram_business: `/images/icons/social/dark-gray/instagram.svg`,
    facebook: `/images/icons/social/dark-gray/facebook.svg`,
    facebook_2: `/images/icons/social/dark-gray/facebook.svg`,
    'facebook-profile': `/images/icons/social/dark-gray/facebook.svg`,
    linkedin: `/images/icons/social/dark-gray/linkedin.svg`,
    stories: `/images/icons/social/stories-and-reels.svg`,
    twitter: `/images/icons/social/dark-gray/twitter.svg`,
    tiktok: `/images/icons/social/dark-gray/tiktok.svg`,
    youtube: `/images/icons/social/dark-gray/youtube.svg`,
    google_my_business: `/images/icons/social/dark-gray/google-my-business.svg`,
  },
};

export const socialMetadata = (
  whiteIcon: boolean = false
): SocialMetadata[] => [
  {
    slug: Socials.Instagram,
    icon: `/images/icons/social/instagram${whiteIcon ? '-white' : ''}.svg`,
    title: getPlatformName('instagram'),
  },
  {
    slug: Socials.InstagramBusiness,
    icon: `/images/icons/social/instagram${whiteIcon ? '-white' : ''}.svg`,
    title: getPlatformName('instagram_business'),
  },
  {
    slug: Socials.Facebook,
    icon: `/images/icons/social/facebook${whiteIcon ? '-white' : ''}.svg`,
    title: getPlatformName('facebook'),
  },
  {
    slug: Socials.Google_my_business,
    icon: `/images/icons/social/facebook${whiteIcon ? '-white' : ''}.svg`,
    title: getPlatformName('google_my_business'),
  },
  {
    slug: Socials.Facebook2,
    icon: `/images/icons/social/facebook${whiteIcon ? '-white' : ''}.svg`,
    title: getPlatformName('facebook_2'),
  },
  {
    slug: Socials.FacebookProfile,
    icon: `/images/icons/social/facebook${whiteIcon ? '-white' : ''}.svg`,
    title: getPlatformName('facebook-profile'),
  },
  {
    slug: Socials.Linkedin,
    icon: `/images/icons/social/linkedin${whiteIcon ? '-white' : ''}.svg`,
    title: getPlatformName('linkedin'),
  },
  {
    slug: Socials.Twitter,
    icon: `/images/icons/social/twitter${whiteIcon ? '-white' : ''}.svg`,
    title: getPlatformName('twitter'),
  },
  {
    slug: Socials.Tiktok,
    icon: `/images/icons/social/tiktok${whiteIcon ? '-white' : ''}.svg`,
    title: getPlatformName('tiktok'),
  },
  {
    slug: Socials.Youtube,
    icon: `/images/icons/social/youtube${whiteIcon ? '-white' : ''}.svg`,
    title: getPlatformName('youtube'),
  },
];

export const shareSocialMetadata: ShareSocialMetadata[] = [
  {
    slug: Socials.Facebook,
    icon: '/images/icons/share/facebook.svg',
    iconNative: '/images/icons/share/native/facebook.svg',
    title: getPlatformName(Socials.Facebook),
  },
  {
    slug: Socials.Google_my_business,
    icon: '/next-public/icons/socials/colored/google-my-business-icon.svg',
    iconNative:
      '/next-public/icons/socials/colored/google-my-business-icon.svg',
    title: getPlatformName(Socials.Google_my_business),
  },
  {
    slug: Socials.Facebook2,
    icon: '/images/icons/share/facebook.svg',
    iconNative: '/images/icons/share/native/facebook.svg',
    title: getPlatformName(Socials.Facebook2),
  },
  {
    slug: Socials.FacebookProfile,
    icon: '/images/icons/share/facebook.svg',
    iconNative: '/images/icons/share/native/facebook.svg',
    title: getPlatformName(Socials.FacebookProfile),
  },
  {
    slug: Socials.Instagram,
    icon: '/images/icons/share/instagram.svg',
    iconNative: '/images/icons/share/native/instagram.svg',
    title: getPlatformName(Socials.Instagram),
  },
  {
    slug: Socials.Linkedin,
    icon: '/images/icons/share/linkedin.svg',
    iconNative: '/images/icons/share/native/linkedin.svg',
    title: getPlatformName(Socials.Linkedin),
  },
  {
    slug: Socials.Twitter,
    icon: '/images/icons/share/twitter.svg',
    iconNative: '/images/icons/share/twitter.svg',
    title: getPlatformName(Socials.Twitter),
  },
  {
    slug: Socials.Youtube,
    icon: '/images/icons/share/youtube.svg',
    iconNative: '/images/icons/share/youtube.svg',
    title: getPlatformName(Socials.Youtube),
  },
  {
    slug: Socials.Google_my_business,
    icon: '/images/icons/share/youtube.svg',
    iconNative: '/images/icons/share/youtube.svg',
    title: getPlatformName(Socials.Google_my_business),
  },
];

export const socialMetadataWithSvgIcons = [
  {
    slug: Socials.Instagram,
    icon: socialMediaIcons.black.instagram,
    title: getPlatformName(Socials.Instagram),
  },
  {
    slug: Socials.Facebook,
    icon: socialMediaIcons.black.facebook,
    title: getPlatformName(Socials.Facebook),
  },
  {
    slug: Socials.Facebook2,
    icon: socialMediaIcons.black.facebook,
    title: getPlatformName(Socials.Facebook2),
  },
  {
    slug: Socials.FacebookProfile,
    icon: socialMediaIcons.black.facebook,
    title: getPlatformName(Socials.FacebookProfile),
  },
  {
    slug: Socials.Linkedin,
    icon: socialMediaIcons.black.linkedin,
    title: getPlatformName(Socials.Linkedin),
  },
  {
    slug: Socials.Twitter,
    icon: socialMediaIcons.black.twitter,
    title: getPlatformName(Socials.Twitter),
  },
  {
    slug: Socials.Youtube,
    icon: socialMediaIcons.black.youtube,
    title: getPlatformName(Socials.Youtube),
  },
  {
    slug: Socials.Google_my_business,
    icon: '/images/icons/social/dark-gray/google-my-business.svg',
    title: getPlatformName(Socials.Google_my_business),
  },
  {
    slug: Socials.Tiktok,
    icon: socialMediaIcons.black.tiktok,
    title: getPlatformName(Socials.Tiktok),
  },
  {
    slug: Socials.Wordpress,
    icon: socialMediaIcons.square.wordpress,
    title: getPlatformName(Socials.Wordpress),
  },
];
